import MuiChip from '@mui/material/Chip'
import { styled } from '@mui/system'

const shouldForwardProp = (prop) => !['color', 'textColor'].includes(prop)

const ChipStyled = styled(MuiChip, {
	shouldForwardProp,
})`
	${({ color }) => (color ? `background-color: ${color};` : '')}
	${({ textColor }) => (textColor ? `color: ${textColor};` : '')}
`

export { ChipStyled }
